import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { Badge, Table } from "react-bootstrap";
import DeleteModal from "../../../../common/DeleteModal";
import { useState } from "react";
import MatchesService from "../../../../../services/MatchesService";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import pinIcon from "../../../../../images/icons/pin.svg";
import unpinIcon from "../../../../../images/icons/unpin.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ConfirmModal from "../../../../common/ConfirmModal";

const Public = ({ data, setShouldUpdate }) => {
	const lang = useSelector((state) => state.auth?.lang);
	const [deleteModal, setDeleteModal] = useState(false);
	const [item, setItem] = useState({});
	const [changeModal, setChangeModal] = useState(false);
	const navigate = useNavigate();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const matchesService = new MatchesService();

	const changeStatusToggle = () => {
		let type = !item?.pined ? "public/pin" : "public/removePin";
		matchesService?.changePin(type, item?.id).then((res) => {
			if (res?.status) {
				toast.success("Pin Changed Successfully");
				setItem({});
				setShouldUpdate((prev) => !prev);
			}
		});
	};

	return (
		<Table responsive>
			<thead>
				<tr className="text-center">
					<th>
						<strong>I.D</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.court}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.date}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.time}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.type}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.level}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.price}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.note}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.court_booking}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.status}</strong>
					</th>
					<th>
						<strong>{Translate[lang]?.action}</strong>
					</th>
				</tr>
			</thead>

			<tbody className="table-body">
				{data?.map((item, index) => {
					return (
						<tr key={index} className="text-center">
							<td>{item?.id}</td>
							<td className="text-wrap-mode text-capitalize">
								{!!item?.court?.name_en ? item?.court[`name_${lang}`] : "-"}
							</td>
							<td className="text-wrap-mode">
								{item?.date?.split("T")[0] || "-"}
							</td>
							<td className="text-wrap-mode">{item?.time || "-"}</td>
							<td className="text-wrap-mode text-capitalize">
								{item?.type || "-"}
							</td>
							<td className="text-wrap-mode text-capitalize">
								{item?.level || "-"}
							</td>
							<td className="text-wrap-mode">
								{item?.court_price?.toFixed(3) || "-"}{" "}
								{!!item?.court_price ? Translate[lang].kwd : ""}
							</td>
							<td className="text-wrap-mode">{item?.note || "-"}</td>
							<td>
								{item?.is_court_booked
									? Translate[lang].yes
									: Translate[lang].no || "-"}
							</td>

							<td>
								<Badge
									className="text-capitalize"
									variant={`${
										item?.status === "active" ? "success" : "danger"
									} light`}>
									{
										Translate[lang][
											item?.status === "active" ? "active" : "deactive"
										]
									}
								</Badge>
							</td>
							<td>
								<div className="d-flex" style={{ gap: "20px" }}>
									{(isExist("update_pin_market_place") ||
										isExist("add_pin_market_place") ||
										isExist("delete_pin_market_place")) && (
										<img
											src={item?.pined ? unpinIcon : pinIcon}
											onClick={() => {
												setItem(item);
												setChangeModal(true);
											}}
											className="cursor-pointer"
											alt="edit"
											width={24}
										/>
									)}
									{isExist("update_matches") && (
										<img
											src={editIcon}
											onClick={() =>
												navigate("/matches/add-matches", { state: item })
											}
											className="cursor-pointer"
											alt="edit"
											width={24}
										/>
									)}
									{isExist("delete_matches") && (
										<img
											src={trashIcon}
											onClick={() => {
												setItem(item);
												setDeleteModal(true);
											}}
											className="cursor-pointer"
											alt="trash"
											width={24}
										/>
									)}
								</div>
							</td>
							{deleteModal && (
								<DeleteModal
									open={deleteModal}
									titleMsg={item?.court?.en ? item?.court[`name_${lang}`] : "-"}
									deletedItem={item}
									type="public"
									modelService={new MatchesService()}
									onCloseModal={setDeleteModal}
									setShouldUpdate={setShouldUpdate}
								/>
							)}
							{changeModal && (
								<ConfirmModal
									open={changeModal}
									title={item?.court?.en ? item?.court[`name_${lang}`] : "-"}
									body={
										lang === "en"
											? `are you sure about changing Pin for this Match?`
											: "هل أنت متأكد من تغيير التثبيت لهذه المباراه؟"
									}
									button={Translate[lang].submit}
									submitButton={changeStatusToggle}
									onCloseModal={() => setChangeModal(false)}
								/>
							)}
						</tr>
					);
				})}
			</tbody>
		</Table>
	);
};
export default Public;
